import { render, staticRenderFns } from "./myWallet.vue?vue&type=template&id=bdb882d4"
import script from "./myWallet.vue?vue&type=script&lang=js"
export * from "./myWallet.vue?vue&type=script&lang=js"
import style0 from "./myWallet.vue?vue&type=style&index=0&id=bdb882d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports